import { http } from '@/http'

// DEF-01: parámetros legales con vigencia por rango de fechas.
export default {
  // Catálogo con todas sus vigencias (las tres pestañas). companyId filtra las tasas por empresa.
  list(companyId)          { return http.get('/legal-parameters', { params: { companyId } }) },
  // Valores generales vigentes a una fecha (YYYY-MM-DD): { RMV: 1230, FAMILY_ALLOWANCE_RATE: 0.1, ... }.
  valuesAt(date)           { return http.get('/legal-parameters/at', { params: { date } }) },
  // Valor vigente a una fecha de un parámetro (global, por régimen o por empresa). Falla si no hay vigencia.
  valueAt(params)          { return http.get('/legal-parameters/value', { params }) },
  // Nueva vigencia: cierra automáticamente la anterior el día previo.
  createVigencia(data)     { return http.post('/legal-parameters/vigencias', data) },
  // Editar una vigencia sin cálculos asociados (valor, base legal, notas).
  updateVigencia(id, data) { return http.put(`/legal-parameters/vigencias/${id}`, data) },
}
